import { render, staticRenderFns } from "./HighlightMenus.vue?vue&type=template&id=ffde2b08&scoped=true&"
import script from "./HighlightMenus.vue?vue&type=script&lang=js&"
export * from "./HighlightMenus.vue?vue&type=script&lang=js&"
import style0 from "./HighlightMenus.vue?vue&type=style&index=0&id=ffde2b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffde2b08",
  null
  
)

export default component.exports